/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_2025_Q1Inputs */

const en_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Exclusive Trees  | Corn Poppy、White Rose、Money Fortune Tree、Moth Orchid、Iris |  
| --- | --- | 
| Selected Trees | Narcissus、Lantern Flower、Wishing Tree、 Camellia、Plum Blossom、Tulip、Lover Tree、Weeping Willow、Unicorn Tree、Cat-tail Willow、Pink Oak Tree、Chinese Bamboo、Maple、Sunflower、Cherry Blossom |
| Plus-Exclusive Sounds | Japanese Garden、Waterfall (White Noise)、Waterfall (Brown Noise) |
| Selected Sounds | Café in Paris、Night forest、(Lofi) Fragments of Time、(Lofi) Blooming Memories、(Lofi) Dappled Rhythms、(Lofi) Lazy Rose Dance、(Lofi) Spring Steps |`)
};

const ar_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| اشجار بلس الحصرية | زهرة الخشخاش ، الوردة البيضاء ، شجرة المال والثروة زهرة الأوركيد ، إيريس | 
 | --- | --- | 
 | أشجار مختارة | نرجس ، زهرة الفانوس ، شجرة الأمنيات ، كاميليا ، زهرة البرقوق ، توليب ، شجرة المحبين ، شجرة الصفصاف ، شجرة اليونيكورن ، شجرة اليونيكورن ، ذيل القطة ، شجرة بلوط بنك ، البامبو الصينى ، شجرة المابل عباد الشمس ، شجرة الكرز | 
 | اصوات بلس الحصرية | الحديقة اليابانية ، شلال (ضوضاء بيضاء) ، شلال (ضوضاء بنية) | 
 | الأصوات المختارة | مقهى فى باريس ، ليل الغابة ، (لوفي) أجزاء من الزمن ،(لوفي) ذكريات مزدهرة ، (لوفي) إيقاعات مقطعة ، (لوفي) رقصة الوردة الكسولة ، (لوفي) خطوات الربيع |`)
};

const de_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Exclusive Trees | Klatschmohn、Weiße Rose、Geld-Glücksbaum、Mottenorchidee、Iris | 
| --- | --- | 
| Ausgewählte Bäume | Narzisse、Laternenblume、Wunschbaum、 Kamelie、Pflaumenblüte、Tulpe、Baum der Liebenden、Trauerweide、Einhornbaum、Salix argyracea、 Chinesischer Bambus、Ahorn、Sonnenblume、Kirschblüte |
| Plus-Exclusive Sounds | Japanischer Garten、Wasserfall (Weißes Rauschen)、Wasserfall (Braunes Rauschen)） |
| Ausgewählte Klänge | Café in Paris、Nächtlicher Wald、(Lofi) Fragmente der Zeit、(Lofi) Blühende Erinnerungen、(Lofi) Gedämpfte Rhythmen、(Lofi) Lazy Rose Dance、(Lofi) Spring Steps |`)
};

const es_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Árboles Exclusivos Plus | Amapola de maíz, Rosa blanca, Árbol del dinero, Iris |  
| --- | --- |
| Árboles Seleccionados | Narciso, Flor de Linterna, Árbol de los deseos, Camelia, Flor de ciruelo, Tulipán, Arbol de Amantes, Sauce Llorón, Árbol de unicornio, Sauce De Cola De Gato, Roble rosa, Bambú Chino, Arce, Girasol, Flor de cerezo |
| Sonidos Exclusivos Plus | Jardín japonés, Cascada (ruido blanco), Cascada (ruido marrón) |
| Sonidos Seleccionados | Café en París、Bosque nocturno、(Lofi) Fragmentos del Tiempo、(Lofi) Recuerdos Florecientes、(Lofi) Ritmos Moteados、(Lofi) Baile de la Rosa Perezosa、(Lofi) Pasos de Primavera |`)
};

const fr_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Arbres exclusifs Plus | Coquelicot、Rose blanche、Arbre de la Fortune、Orchidée Papillon、Iris |
| --- | --- |
| Arbres sélectionnés | Narcisse、Fleur Lanterne、Arbre à souhaits、Camélia、Fleur de prunier、Tulipe、Arbre des amants、Saule Pleureur、Arbre de licorne、Saule de chat、Chêne rose、Bambou Chinois、Érable、Tournesol、Cerisier en fleur |
| Sons exclusifs Plus | Jardin japonais、Cascade (bruit blanc)、Cascade (bruit brun) |
| Sons sélectionnés | Café à Paris、Forêt de nuit、(Lofi) Fragments du temps、(Lofi) Éclosion de Souvenirs、(Lofi) Rythmes d'Ombres et de Lumière、(Lofi) Valse Tranquille des Roses、(Lofi) Éveil du Printemps |`)
};

const it_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Più alberi esclusivi | Papavero、Rosa Bianca、Albero della Fortuna、Orchidea Falenopsis、Iris |  
| --- | --- | 
| Alberi selezionati | Narciso、Fiore Lanterna、Albero dei Desideri、 Camelia、Fiore di Pruno、Tulipano、Albero degli Innamorati、Salice Piangente、Albero Unicorno、Tifa a Coda di Gatto、Quercia Rosa、Bambù Cinese、Acero、Girasole、Fiore di Ciliegio |
| Più suoni esclusivi | Giardino Giapponese、Cascata (rumore bianco)、Cascata (rumore marrone)） |
| Suoni selezionati | Café di Parigi、Foresta notturna、(Lofi) Frammenti di tempo、(Lofi) Ricordi in fiore、(Lofi) Ritmi maculati、(Lofi) Danza delle rose pigre、(Lofi) Passi primaverili |`)
};

const ja_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus限定の木 | ヒナゲシ、ホワイトローズ、金のなる幸運の木、胡蝶蘭、アイリス | 
 | --- | --- | 
 | 厳選された木 | スイセン、願いの木、ランタンの花、願いの木、ツバキ、梅の花、チューリップ、恋人の木、シダレヤナギ、ユニコーンの木、ネコのしっぽヤナギ、ピンクのナラの木、新年の竹、もみじ、ヒマワリ、桜 | 
 | Plus限定サウンド | 日本庭園、滝（ホワイトノイズ）、滝（ブラウンノイズ） | 
 | 厳選サウンド | パリのカフェ、夜の森、(Lo-Fi) 時の欠片、(Lo-Fi) 花開く思い出、(Lo-Fi) きらめくリズム、(Lo-Fi) ゆったりとしたバラの舞、(Lo-Fi) 春のステップ |`)
};

const ko_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 전용 나무 | 개양귀비,백장미,행운의 돈나무,나방 난초,붓꽃 | 
| --- | --- | 
| 선택된 나무 | 수선화,등불꽃,소망 나무, 동백나무,매화꽃,튤립,사랑의 나무,수양버들,유니콘 나무,갯버들,분홍색 참나무,대나무,단풍 나무,해바라기,벚꽃 |
| Plus 전용 사운드 | 일본식 정원,폭포(화이트 노이즈),폭포(브라운 노이즈)） |
| 선택된 사운드 | 파리의 카페거리、깊은 밤의 숲、(로파이) 시간의 조각들、(로파이) 꽃피는 추억、(로파이) 아롱다롱 리듬、(로파이) 느긋한 장미의 춤사위、(로파이) 봄맞이 스텝 |`)
};

const pt_br_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Árvores exclusivas Plus  | Papoula Comum、Rosa Branca、Árvore da Fortuna、Orquídea Mariposa、Íris |  
| --- | --- | 
| Árvores selecionadas | Narciso、Flor Lanterna、Árvore dos Desejos、 Camélia、Flor de Ameixa、Tulipa、Árvore Enamorada、Salgueiro-Chorão、Árvore Unicórnio、Salgueiro Chinês、Carvalho Rosa、Bambu Chinês、Bordo、Girassol、Cerejeira |
| Sons exclusivos Plus | Jardim Japonês、Cachoeira (ruído branco)、Cachoeira (ruído marrom)） |
| Sons selecionados | Café em Paris、Noite na Floresta、(Lo-Fi) Fragmentos do tempo、(Lo-Fi) Memórias florescentes、(Lo-Fi) Ritmos sarapintados、(Lo-Fi) Vagarosa dança da rosa、(Lo-Fi) Passos de primavera |`)
};

const ru_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Эксклюзивные растения Plus | Полевой мак、Белая роза、Денежное дерево、Фаленопсис、Ирис | 
| --- | --- | 
| Избранные растения | Нарцисс、Цветочек-фонарик、Дерево желаний、 Камелия、Цветение сливы、Тюльпан、Любовное дерево、Плачущая Ива、Дерево единорога、Кошачий хвост Уиллоу、Дуб красный、Китайский бамбук、Клён、Подсолнечник、Сакура |
| Эксклюзивные звуки Plus | Японский сад、Водопад (белый шум)、Водопад (коричневый шум)） |
| Избранные звуки | Кафе в Париже、Ночной лес、(Lo-Fi) Фрагменты времени、(Lo-Fi) Цветущие воспоминания、(Lo-Fi) Пёстрые ритмы、(Lo-Fi) Ленивый танец роз、(Lo-Fi) Весеннее погружение |`)
};

const th_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| ต้นไม้สุดพิเศษเฉพาะ Plus  | ป๊อปปี้、กุหลาบขาว、ต้นทรัพย์เงินทอง、กล้วยไม้ผีเสื้อราตรี、ไอริส |  
| --- | --- | 
| ต้นไม้ที่ถูกคัดสรร | นาร์ซิสซัส、ดอกโคมไฟ、ต้นไม้แห่งปรารถนา、 คามีเลีย、ดอกเหมย、ทิวลิป、ต้นคู่รัก、หลิวลู่ลม、ต้นยูนิคอร์น、หลิวหางแมว、ต้นโอ๊กสีชมพู、ไผ่จีน、ต้นเมเปิ้ล、ดอกทานตะวัน、ต้นซากุระ |
| เสียงสุดพิเศษเฉพาะ Plus | สวนญี่ปุ่น、น้ำตก (เสียงสีขาว)、น้ำตก (เสียงสีน้ำตาล)） |
| เสียงที่ถูกคัดสรร | คาเฟ่ในปารีส、ป่ายามค่ำคืน、(Lofi) เศษเสี้ยวแห่งเวลา、(Lofi) ความทรงจำอันเบ่งบาน、(Lofi) จังหวะแห่งแสงเงา、(Lofi) ดอกกุหลาบร่ายรำ、(Lofi) ย่างก้าวแห่งฤดูใบไม้ผลิ |`)
};

const tr_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus-Özel Ağaçlar | Gelincik、Beyaz Gül、Para Servet Ağacı、Ay Orkidesi、Süsen Çiçeği | 
| --- | --- | 
| Seçilen Ağaçlar | Nergis、Fener Çiçeği、Dilek Ağacı、 Kamelya、Erik Çiçeği、Lale、Aşıklar Ağacı、Salkım Söğüt、Tek Boynuzlu At Ağacı、Kedi kuyruğu söğüdü、Pembe Meşe Ağacı、Çin Bambu Ağacı、Akçaağaç、Ayçiçeği、Kiraz Çiçeği |
| Plus Özel Sesleri | Japon Bahçesi、Şelale (Beyaz Gürültü)、Şelale (Kahverengi Gürültü)） |
| Seçilen Sesler | Paris'te Bir Kafe、Gece Ormanı、(Lofi) Zaman Parçaları、(Lofi) Çiçek Açan Anılar、(Lofi) Alacalı Ritimler、(Lofi) Tembel Gül Dansı、(Lofi) Bahar Adımları |`)
};

const zh_cn_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 独享树种  | 虞美人、白玫瑰、招财树、蝴蝶兰、鸢尾花 |  
| --- | --- | 
| 特选树种 | 水仙花、灯花、祈愿树、 山茶花、梅花、郁金香、情人树、柳树、独角兽树、银柳、粉红色橡树、新年竹、枫树、向日葵、樱花 |
| Plus 独享声音 | 日式庭园、瀑布（白噪音）、瀑布（棕噪音） |
| 特选声音 | 巴黎咖啡馆、夜半森林、(Lofi) 时光碎片、(Lofi) 花之记忆、(Lofi) 树影旋律、(Lofi) 玫瑰花的慵懒、(Lofi) 春日步调 |`)
};

const zh_tw_content_2025_q1 = /** @type {(inputs: Content_2025_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`| Plus 獨享樹種  | 虞美人、白玫瑰、招財樹、蝴蝶蘭、鳶尾花 |  
| --- | --- | 
| 精選樹種 | 水仙花、燈花、祈願樹、 山茶花、梅花、鬱金香、情人樹、柳樹、獨角獸樹、銀柳、粉紅色橡樹、新年竹、楓樹、向日葵、櫻花 |
| Plus 獨享聲音 | 日式庭園、瀑布（白噪音）、瀑布（棕噪音） |
| 精選聲音 | 巴黎咖啡館、夜半森林、(Lofi) 時光碎片、(Lofi) 花之記憶、(Lofi) 樹影旋律、(Lofi) 玫瑰花的慵懶、(Lofi) 春日步調 |`)
};

/**
* | output |
* | --- |
* | "\| Plus-Exclusive Trees \| Corn Poppy、White Rose、Money Fortune Tree、Moth Orchid、Iris \| \| --- \| --- \| \| Selected Trees \| Narcissus、Lantern Flower、Wishing Tree、 ..." |
*
* @param {Content_2025_Q1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const content_2025_q1 = /** @type {((inputs?: Content_2025_Q1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_2025_Q1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_content_2025_q1(inputs)
	if (locale === "ar") return ar_content_2025_q1(inputs)
	if (locale === "de") return de_content_2025_q1(inputs)
	if (locale === "es") return es_content_2025_q1(inputs)
	if (locale === "fr") return fr_content_2025_q1(inputs)
	if (locale === "it") return it_content_2025_q1(inputs)
	if (locale === "ja") return ja_content_2025_q1(inputs)
	if (locale === "ko") return ko_content_2025_q1(inputs)
	if (locale === "pt_br") return pt_br_content_2025_q1(inputs)
	if (locale === "ru") return ru_content_2025_q1(inputs)
	if (locale === "th") return th_content_2025_q1(inputs)
	if (locale === "tr") return tr_content_2025_q1(inputs)
	if (locale === "zh_cn") return zh_cn_content_2025_q1(inputs)
	return zh_tw_content_2025_q1(inputs)
});